/**
 * Vanilla JS animations for toiuuweb.codetot.vn
 * Replaces React + framer-motion (~200 KiB) with ~3 KiB vanilla JS
 */
(function () {
  'use strict';

  // ── 1. Scroll-triggered fade-in animations ──
  var animateEls = document.querySelectorAll('[data-animate]');
  if (animateEls.length) {
    var animObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          animObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    animateEls.forEach(function (el) { animObs.observe(el); });
  }

  // ── 2. Header blur on scroll ──
  var header = document.querySelector('[data-header]');
  if (header) {
    var scrolled = false;
    var headerTicking = false;
    var onHeaderScroll = function () {
      if (headerTicking) return;
      headerTicking = true;
      requestAnimationFrame(function () {
        headerTicking = false;
        var now = window.scrollY > 20;
        if (now !== scrolled) {
          scrolled = now;
          if (scrolled) {
            header.classList.add('header-scrolled');
            header.classList.remove('header-top');
          } else {
            header.classList.remove('header-scrolled');
            header.classList.add('header-top');
          }
        }
      });
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  // ── 3. Count-up numbers ──
  var countUpEls = document.querySelectorAll('[data-count-up]');
  if (countUpEls.length) {
    var countObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseFloat(el.getAttribute('data-count-up'));
          var prefix = el.getAttribute('data-count-prefix') || '';
          var suffix = el.getAttribute('data-count-suffix') || '';
          var decimals = (el.getAttribute('data-count-up').split('.')[1] || '').length;
          var duration = 1500;
          var startTime = performance.now();

          function step(now) {
            var progress = Math.min((now - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
            var current = target * eased;
            el.textContent = prefix + current.toFixed(decimals) + suffix;
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
          countObs.unobserve(el);
        }
      });
    }, { threshold: 0.1 });
    countUpEls.forEach(function (el) { countObs.observe(el); });
  }

  // ── 4. Checklist loop animation ──
  var checklistGrid = document.querySelector('[data-checklist]');
  if (checklistGrid) {
    var items = checklistGrid.querySelectorAll('[data-checklist-item]');
    var checkInterval = 400;
    var pauseAfterComplete = 2000;
    var checklistInView = false;
    var checkTimers = [];

    var clearCheckTimers = function () {
      checkTimers.forEach(clearTimeout);
      checkTimers = [];
    };

    var resetChecklist = function () {
      items.forEach(function (item) {
        item.classList.remove('checklist-checked');
      });
    };

    var runCheckCycle = function () {
      if (!checklistInView) return;
      resetChecklist();
      items.forEach(function (item, i) {
        checkTimers.push(setTimeout(function () {
          item.classList.add('checklist-checked');
        }, (i + 1) * checkInterval));
      });
      checkTimers.push(setTimeout(function () {
        runCheckCycle();
      }, items.length * checkInterval + pauseAfterComplete));
    };

    var checkObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          checklistInView = true;
          runCheckCycle();
        } else {
          checklistInView = false;
          clearCheckTimers();
          resetChecklist();
        }
      });
    }, { threshold: 0.1 });
    checkObs.observe(checklistGrid);
  }

  // ── 5. Progress bars (Before/After metrics) ──
  var metricSections = document.querySelectorAll('[data-metric-section]');
  metricSections.forEach(function (section) {
    var bars = section.querySelectorAll('[data-metric-bar]');
    var metricObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          bars.forEach(function (bar) {
            bar.style.width = bar.getAttribute('data-metric-bar') + '%';
          });
          metricObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    metricObs.observe(section);
  });

  // ── 6. Mobile plan selector ──
  var planSelector = document.querySelector('[data-plan-select]');
  if (planSelector) {
    var planNames = ['F-Fast', 'F-Max', 'F-MaxPro'];
    var planPriceValues = ['2.000.000', '4.000.000', '6.000.000'];
    var planDescValues = [
      'Tối ưu cơ bản cho website cần cải thiện tốc độ nhanh chóng.',
      'Tối ưu chuyên sâu cho website cần đạt chuẩn Core Web Vitals.',
      'Tối ưu toàn diện, can thiệp code chuyên sâu cho website lớn & e-commerce.'
    ];
    var planCtaTexts = ['Chọn F-Fast', 'Chọn F-Max', 'Chọn F-MaxPro'];
    var planFeatureRows = document.querySelectorAll('[data-plan-feature-row]');

    var compareFeatures = [
      { label: 'Tối ưu chỉ số PageSpeed', category: true, values: [] },
      { label: 'Performance Mobile', values: ['70+', '85+', '90+'] },
      { label: 'Performance Desktop', values: ['85+', '95+', '95+'] },
      { label: 'Số lượng xử lý theo vấn đề PageSpeed', values: ['Tối đa 5', 'Tối đa 10', 'Không giới hạn'] },
      { label: 'Tối ưu TBT (Total Blocking Time)', values: [true, true, true] },
      { label: 'Tối ưu FCP (First Contentful Paint)', values: [true, true, true] },
      { label: 'Tối ưu Speed Index', values: [false, true, true] },
      { label: 'Khắc phục CLS (Cumulative Layout Shift)', values: [false, true, true] },
      { label: 'Khắc phục LCP (Largest Contentful Paint)', values: [false, true, true] },
      { label: 'Tối ưu tốc độ truy cập thực tế', category: true, values: [] },
      { label: 'Thời gian tải trang Desktop tối đa', values: ['3s', '2s', '1.5s'] },
      { label: 'Thời gian tải trang Mobile tối đa', values: ['5s', '3.5s', '2.5s'] },
      { label: 'Tối ưu hình ảnh', category: true, values: [] },
      { label: 'Cấu hình nén hình ảnh (WebP/AVIF)', values: [true, true, true] },
      { label: 'Số lượng hình ảnh kiểm tra & nén', values: ['Tối đa 200', 'Tối đa 500', 'Không giới hạn'] },
      { label: 'Bao gồm license nén ảnh không giới hạn', values: [false, false, true] },
      { label: 'Thời gian, tiến độ và bảo hành', category: true, values: [] },
      { label: 'Thời gian thực hiện trung bình', values: ['3-5 ngày', '5-7 ngày', '7-10 ngày'] },
      { label: 'Tổng thời gian thực hiện (theo số template)', values: ['1 template', '2 template', '3+ template'] },
      { label: 'Thời gian bảo hành', values: ['1 tháng', '2 tháng', '3 tháng'] },
      { label: 'Báo cáo Page Experience trước & sau', values: [false, true, true] },
      { label: 'Chính sách hoàn tiền', values: [false, false, 'Hoàn tiền nếu không đạt'] },
      { label: 'Cài đặt các plugin cải thiện hiệu suất', category: true, values: [] },
      { label: 'Audit & cấu hình Cache', values: [true, true, true] },
      { label: 'Minify JS', values: [true, true, true] },
      { label: 'Combine JS', values: [false, true, true] },
      { label: 'Minify CSS', values: [true, true, true] },
      { label: 'Combine CSS', values: [false, true, true] },
      { label: 'Critical CSS support', values: [false, true, true] },
      { label: 'Lazy load hình ảnh', values: [true, true, true] },
      { label: 'Lazy load iframe', values: [true, true, true] },
      { label: 'Tối ưu font loading (self-host / preload)', values: [false, true, true] },
      { label: 'Khả năng can thiệp và đề xuất code', category: true, values: [] },
      { label: 'Chỉnh sửa theme', values: [false, false, true] },
      { label: 'Phí chỉnh sửa template bổ sung', values: ['Không hỗ trợ', 'Báo giá riêng', 'Báo giá riêng'] },
      { label: 'Chỉnh sửa plugin', values: [false, false, true] }
    ];

    var checkSvg = '<svg class="w-5 h-5 text-emerald-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 6 9 17l-5-5"/></svg>';
    var dashSpan = '<span class="text-muted-foreground/40 text-sm">\u2014</span>';

    var updatePlan = function () {
      var idx = parseInt(planSelector.value, 10);
      var infoEl = document.querySelector('[data-plan-info]');
      if (infoEl) {
        infoEl.innerHTML = '<span class="text-2xl font-bold text-foreground">' + planPriceValues[idx] + 'đ</span>' +
          '<span class="text-muted-foreground">/lần</span>' +
          '<p class="text-xs text-muted-foreground mt-1">' + planDescValues[idx] + '</p>';
      }

      var featuresEl = document.querySelector('[data-plan-features]');
      if (featuresEl) {
        var html = '';
        compareFeatures.forEach(function (row) {
          if (row.category) {
            html += '<div class="pt-6 pb-2 px-1"><span class="text-xs font-bold text-primary uppercase tracking-wider">' + row.label + '</span></div>';
            return;
          }
          var val = row.values[idx];
          var valHtml;
          if (val === true) valHtml = checkSvg;
          else if (val === false) valHtml = dashSpan;
          else valHtml = '<span class="text-sm font-semibold text-foreground">' + val + '</span>';
          html += '<div class="flex items-center justify-between py-2.5 px-3 rounded-lg odd:bg-secondary/30"><span class="text-sm text-foreground">' + row.label + '</span><span class="shrink-0 ml-3">' + valHtml + '</span></div>';
        });
        featuresEl.innerHTML = html;
      }

      var planCta = document.querySelector('[data-plan-cta]');
      if (planCta) planCta.textContent = 'Tư vấn gói ' + planNames[idx];
    };

    planSelector.addEventListener('change', updatePlan);
    updatePlan();
  }

  // ── 7. Floating CTA (desktop, appears at 25% scroll) ──
  var floatingCta = document.querySelector('[data-floating-cta]');
  if (floatingCta) {
    var ctaAppeared = false;
    var ctaTicking = false;
    var onCtaScroll = function () {
      if (ctaAppeared || ctaTicking) return;
      ctaTicking = true;
      requestAnimationFrame(function () {
        ctaTicking = false;
        if (ctaAppeared) return;
        var pct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
        if (pct >= 0.25) {
          ctaAppeared = true;
          floatingCta.style.opacity = '1';
          floatingCta.style.transform = 'translateX(0)';
          setTimeout(function () {
            floatingCta.querySelectorAll('[data-cta-expand]').forEach(function (el) {
              el.setAttribute('data-expanded', 'true');
            });
          }, 3000);
          setTimeout(function () {
            floatingCta.classList.add('animate-[subtle-pulse_3s_ease-in-out_infinite]');
          }, 6000);
        }
      });
    };
    window.addEventListener('scroll', onCtaScroll, { passive: true });
  }

  // ── 8. Mobile sticky bar (appears at 25% scroll) ──
  var mobileSticky = document.querySelector('[data-mobile-sticky]');
  if (mobileSticky) {
    var stickyAppeared = false;
    var stickyTicking = false;
    var onStickyScroll = function () {
      if (stickyAppeared || stickyTicking) return;
      stickyTicking = true;
      requestAnimationFrame(function () {
        stickyTicking = false;
        if (stickyAppeared) return;
        var pct = window.scrollY / (document.documentElement.scrollHeight - window.innerHeight);
        if (pct >= 0.25) {
          stickyAppeared = true;
          mobileSticky.style.opacity = '1';
          mobileSticky.style.transform = 'translateY(0)';
        }
      });
    };
    window.addEventListener('scroll', onStickyScroll, { passive: true });
  }

  // ── 9. Smooth scroll for anchor links ──
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (target) {
        e.preventDefault();
        var offset = 80;
        var top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  });
})();
